export function numberToHumanSize(bytes) {
  // Intl.NumberFormat は2進接頭辞のバイトはサポートしてないっぽいので自力で実装
  // Windows は計算方法は2進だが表示する単位は10進なので、それに合わせる
  const PREFIXES = ['', 'K', 'M', 'G', 'T'];
  const BASE = 2 ** 10;
  const MAX_EXPONENT = PREFIXES.length - 1;
  const exponent =
    bytes === 0
      ? 0
      : Math.min(
          Math.floor(
            // 対数の基本的な性質より
            // log_b(x) = log_a(x) / log_a(b)
            Math.log(bytes) / Math.log(BASE),
          ),
          MAX_EXPONENT,
        );
  const size = bytes / BASE ** exponent;
  // 数値部分の整形だけIntl.NumberFormatを使う
  const formatter = new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3,
  });

  return `${formatter.format(size)} ${PREFIXES[exponent]}B`;
}
